<div class="nc-galleria" #galleriaContainer [style.width]="ncWidth" [style.height]="ncHeight"
    (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" tabindex="0" role="img"
    [attr.aria-label]="'图片画廊，当前第' + (currentIndex + 1) + '张，共' + ncImages.length + '张'"
    *ngIf="ncImages && ncImages.length > 0">

    <!-- 主图显示区域 -->
    <div class="galleria-main">
        <div class="main-image-container" [class.nav-hover-mode]="ncNavButtonsDisplay === 'hover'"
            [class.full-hover-mode]="ncFullscreenButtonDisplay === 'hover'">
            <img [src]="ncImages[currentIndex].src" [style.object-fit]="ncObjectFit" [alt]="'图片 ' + (currentIndex + 1)"
                [class.clickable]="ncEnableFullscreen" (error)="onImageError($event)"
                (click)="ncEnableFullscreen && openFullscreen()" class="main-image">

            <!-- 数目信息 -->
            <div class="index-container" *ngIf="ncShowIndex && ncImages.length > 1">
                {{currentIndex + 1}} / {{ncImages.length}}
            </div>

            <!-- 标题信息 -->
            <div class="title-container" *ngIf="ncShowTitle && ncImages[currentIndex].title">
                {{ncImages[currentIndex].title}}
            </div>

            <!-- 全屏按钮 -->
            <button class="fullscreen-button" *ngIf="ncEnableFullscreen && ncFullscreenButtonDisplay !== 'hidden'"
                (click)="openFullscreen()" [attr.aria-label]="'全屏预览'">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                        d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>

            <!-- 导航按钮 -->
            <button class="nav-button nav-prev" (click)="previousImage()"
                *ngIf="ncShowNavButtons && ncImages.length > 1" [attr.aria-label]="'上一张图片'">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>

            <button class="nav-button nav-next" (click)="nextImage()" *ngIf="ncShowNavButtons && ncImages.length > 1"
                [attr.aria-label]="'下一张图片'">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>

            <!-- 内部指示器 -->
            <div class="indicators indicators-inside"
                *ngIf="ncShowIndicators && ncIndicatorsPosition === 'inside' && ncImages.length > 1">
                <span class="indicator" *ngFor="let image of ncImages; let i = index"
                    [class.active]="i === currentIndex" [attr.aria-label]="'跳转到第' + (i + 1) + '张图片'" role="button"
                    tabindex="0" (click)="selectImage(i)" (keydown.enter)="selectImage(i)"
                    (keydown.space)="selectImage(i)">
                </span>
            </div>
        </div>
    </div>

    <!-- 缩略图导航 -->
    <div class="galleria-thumbnails" *ngIf="ncShowThumbnails && ncImages.length > 1">
        <div class="thumbnails-container">
            <!-- 左滚动按钮 -->
            <button class="scroll-button scroll-left" (click)="scrollThumbnailsLeft()"
                *ngIf="!shouldCenterThumbnails && canScrollLeft()" [attr.aria-label]="'向左滚动缩略图'">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>

            <!-- 缩略图列表 -->
            <div class="thumbnails-list-container">
                <div class="thumbnails-list" [class.center-thumbnails]="shouldCenterThumbnails"
                    [style.transform]="shouldCenterThumbnails ? 'none' : 'translateX(' + thumbnailTransform + 'px)'">
                    <div class="thumbnail-item" *ngFor="let image of ncImages; let i = index"
                        [class.active]="i === currentIndex" [style.width.px]="ncThumbnailWidth"
                        [style.height.px]="ncThumbnailHeight" [attr.aria-label]="'缩略图 ' + (i + 1)" role="button"
                        tabindex="0" (click)="selectImage(i)" (keydown.enter)="selectImage(i)"
                        (keydown.space)="selectImage(i)">
                        <img [src]="image.src" [alt]="'缩略图 ' + (i + 1)" (error)="onThumbnailError($event)"
                            class="thumbnail-image">
                    </div>
                </div>
            </div>

            <!-- 右滚动按钮 -->
            <button class="scroll-button scroll-right" (click)="scrollThumbnailsRight()"
                *ngIf="!shouldCenterThumbnails && canScrollRight()" [attr.aria-label]="'向右滚动缩略图'">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </div>

    <!-- 外部指示器 -->
    <div class="indicators indicators-outside"
        *ngIf="ncShowIndicators && ncIndicatorsPosition === 'outside' && ncImages.length > 1"
        [ngStyle]="{'margin-top': ncShowThumbnails ? '0' : '12px'}">
        <span class="indicator" *ngFor="let image of ncImages; let i = index" [class.active]="i === currentIndex"
            [attr.aria-label]="'跳转到第' + (i + 1) + '张图片'" role="button" tabindex="0" (click)="selectImage(i)"
            (keydown.enter)="selectImage(i)" (keydown.space)="selectImage(i)">
        </span>
    </div>
</div>

<!-- 空状态 -->
<div class="galleria-empty" [style.width]="ncWidth" [style.height]="ncHeight"
    *ngIf="!ncImages || ncImages.length === 0">
    <div class="empty-content">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" class="empty-icon">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2" />
            <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" stroke-width="2" />
            <polyline points="21,15 16,10 5,21" stroke="currentColor" stroke-width="2" />
        </svg>
        <p>暂无图片</p>
    </div>
</div>

<!-- 全屏预览模态框 -->
<div class="fullscreen-modal" *ngIf="isFullscreen" (click)="closeFullscreen()" (keydown)="onFullscreenKeyDown($event)"
    tabindex="0">
    <div class="fullscreen-content" (click)="$event.stopPropagation()">
        <!-- 关闭按钮 -->
        <button class="fullscreen-close" (click)="closeFullscreen()" [attr.aria-label]="'关闭全屏'">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" />
                <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" />
            </svg>
        </button>

        <!-- 播放/暂停按钮 -->
        <button class="fullscreen-play-pause" *ngIf="ncAutoPlay && ncImages.length > 1"
            (click)="toggleFullscreenAutoPlay()" [attr.aria-label]="isFullscreenAutoPlaying ? '暂停自动播放' : '开始自动播放'">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                *ngIf="!isFullscreenAutoPlaying">
                <!-- 播放图标 -->
                <polygon points="5,3 19,12 5,21" fill="currentColor" />
            </svg>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                *ngIf="isFullscreenAutoPlaying">
                <!-- 暂停图标 -->
                <rect x="6" y="4" width="4" height="16" fill="currentColor" />
                <rect x="14" y="4" width="4" height="16" fill="currentColor" />
            </svg>
        </button>

        <!-- 缩放提示 -->
        <div class="fullscreen-zoom-hint" *ngIf="ncWheelScale">
            <div class="zoom-hint-content">
                <span>滚轮缩放 • 拖拽平移 • 双击重置</span>
            </div>
        </div>

        <!-- 全屏图片 -->
        <img [src]="ncImages[currentIndex].src" [alt]="'全屏预览 - 图片 ' + (currentIndex + 1)" (error)="onImageError($event)"
            class="fullscreen-image" [class.scalable]="ncWheelScale"
            [style.transform]="ncWheelScale ? getFullscreenImageTransform() : ''"
            [style.cursor]="ncWheelScale && fullscreenScale > 1 ? 'grab' : (ncWheelScale ? 'zoom-in' : '')"
            (wheel)="onFullscreenWheel($event)" (mousedown)="onFullscreenMouseDown($event)"
            (mousemove)="onFullscreenMouseMove($event)" (mouseup)="onFullscreenMouseUp($event)"
            (mouseleave)="onFullscreenMouseUp($event)" (dblclick)="onFullscreenDoubleClick($event)">

        <!-- 全屏导航按钮 -->
        <button class="fullscreen-nav fullscreen-nav-prev" (click)="previousImage()" *ngIf="ncImages.length > 1"
            [attr.aria-label]="'上一张图片'">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </button>

        <button class="fullscreen-nav fullscreen-nav-next" (click)="nextImage()" *ngIf="ncImages.length > 1"
            [attr.aria-label]="'下一张图片'">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </button>

        <!-- 全屏指示器 -->
        <div class="fullscreen-indicators" *ngIf="ncImages.length > 1">
            <span class="fullscreen-indicator" *ngFor="let image of ncImages; let i = index"
                [class.active]="i === currentIndex" [attr.aria-label]="'跳转到第' + (i + 1) + '张图片'" role="button"
                tabindex="0" (click)="selectImage(i)" (keydown.enter)="selectImage(i)" (keydown.space)="selectImage(i)">
            </span>
        </div>

        <!-- 图片信息 -->
        <div class="fullscreen-info">
            <span>{{currentIndex + 1}} / {{ncImages.length}}</span>
            <span *ngIf="ncWheelScale" class="zoom-status">
                {{ (fullscreenScale * 100).toFixed(0) }}%
            </span>
            <span *ngIf="ncAutoPlay && ncImages.length > 1" class="autoplay-status">
                {{ isFullscreenAutoPlaying ? '自动播放中' : '已暂停' }}
            </span>
        </div>
    </div>
</div>